import { render, staticRenderFns } from "./GruppeCard.vue?vue&type=template&id=4e8115b8&"
import script from "./GruppeCard.vue?vue&type=script&lang=js&"
export * from "./GruppeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports